import { render } from "./index.vue?vue&type=template&id=464053e8&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=464053e8&scoped=true&lang=less"

import exportComponent from "/Users/xiaobiaoza/Desktop/workspace/GIM/WPP/wpp-aigc-aigc-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464053e8"],['__file',"src/components/imageToolViewer/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "464053e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('464053e8', __exports__)) {
    console.log('reload')
    api.reload('464053e8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=464053e8&scoped=true", () => {
    console.log('re-render')
    api.rerender('464053e8', render)
  })

}


export default __exports__